  document.addEventListener('DOMContentLoaded', function() {
        // Get reference to the elements
        const posterElement = document.querySelector('.deferred-media__poster');
        const preorderElement = document.querySelector('.preorder');

        // Add click event listener to the poster element
        posterElement.addEventListener('click', function() {
            // Hide the preorder element
            preorderElement.classList.add('p-hidden');
        });
    });



// JavaScript to trigger the animation for hero-section text
window.addEventListener('load', function() {
  var elements = document.querySelectorAll('.hero-section .sec-one h1, .hero-section .sec-one h3,.sec-one p, .btns');
  elements.forEach(function(element) {
    element.classList.add('animate');
  });
});


gsap.registerPlugin(ScrollTrigger);

// Define animations
const animations = gsap.utils.toArray('.animated-word').map(word => {
  return gsap.timeline({
    scrollTrigger: {
      trigger: word,
      start: 'top bottom',
      end: 'bottom top',
      toggleActions: 'play none none reverse',
    }
  })
  .from(word, { opacity: 0, y: 0, duration: 0.5, ease: 'power2.out' })
  .to(word, { opacity: 1, y: 0, duration: 0.5, ease: 'power2.out' }, '<');
});





 gsap.registerPlugin(ScrollTrigger);



gsap.registerPlugin(ScrollTrigger);

let isScrollAllowed = true;

const tmln = gsap.timeline({
    scrollTrigger: {
        trigger: "section-3",
        start: "top bottom",
        end: "+=175%",
        scrub: true,
        pin: true,
        onUpdate: self => {
            isScrollAllowed = self.progress > 0 && self.progress < 1;
        }
    }
});

tmln.from(".semi-circle", {
    duration: 2,
    background: "#f9ebff",
    color: "#fff",
})
.to(".semi-circle", {
    duration: 2,
    height: "140%",
    width: "60%",
    scrub: true,
})
.from(".image1", {
    x: "-20vw",
    // duration: 2,
    scrollTrigger: {
        trigger: ".image1",
        start: "top 100%",
        end: "top 10%",
        scrub: true,
    }
})
.to(".image1", {
    x: "0",
    // duration: 2,
    scrollTrigger: {
        trigger: ".image1",
        start: "top 100%",
        end: "top 10%",
        scrub: true,
    }
})
.from(".image2", {
    // duration: 2,
    x: "+20vw",
    scrollTrigger: {
        trigger: ".image2",
        start: "top 90%",
        end: "top 10%",
        scrub: true,
    }
})
.to(".image2", {
    // duration: 2,
    x: "0",
    scrollTrigger: {
        trigger: ".image2",
        start: "top 100%",
        end: "top 10%",
        scrub: true,
    }
}).to(".semi-circle", {
    duration: 1.5,
    height: "100%",
    width: "100%",
  borderRadius:0,
});

document.addEventListener("wheel", e => {
    if (!isScrollAllowed) {
        e.preventDefault();
    }
});





